import type { ElementType, ReactElement, ReactNode } from 'react';
import './MessengerMutedStatus.css';

export interface MessengerMutedStatusProps {
  children: ReactNode;
  /** По умолчанию `p` для одного абзаца; `div` — если внутри несколько узлов (спиннер + текст). */
  as?: ElementType;
  className?: string;
}

export function MessengerMutedStatus({
  children,
  as: Comp = 'p',
  className = '',
}: MessengerMutedStatusProps): ReactElement {
  return (
    <Comp
      className={['messengerMutedStatus', className].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
    >
      {children}
    </Comp>
  );
}
